// imported from ta.customer-profile-client

export enum DesiredFeaturesOptions {
  AppOrRemoteControl = 'App or Remote Control',
  Rechargeable = 'Rechargeable',
  NoiseSuppression = 'Noise suppression',
  ExternalMicrophone = 'External Microphone',
  Streaming = 'Streaming',
  TVConnection = 'TV Connection',
}

export enum Smartphone {
  Android = 'Android',
  iPhone = 'Iphone',
  IOS = 'IOS',
  Windows = 'Windows',
  Other = 'Other',
  WindowsPhone = 'Windows Phone',
  NoSmartphone = 'No smartphone',
}

export enum HearingIssueStartDate {
  OneYear = '1 year',
  TwoYears = '2 years',
  LessThanTwoYears = 'less than 2 years',
  MoreThanTwoYears = 'more than 2 years',
  MoreThanFiveYears = 'more than 5 years',
  LessThanOneYear = 'Less than 1 year',
  OneToThreeYears = '1 to 3 years',
  MoreThanThreeYears = 'More than 3 years',
}

export enum HasTinnitus {
  No = 'No',
  Yes = 'Yes',
  BothEars = 'Both ears',
  LeftEar = 'Left ear',
  RightEar = 'Right ear',
  Unknown = 'Unknown',
  None = 'None',
}

export enum ScaleOfPrescription {
  BothEars = 'Both ears',
  LeftEar = 'Left ear',
  RightEar = 'Right ear',
  Unknown = 'Unknown',
}

export enum Allergies {
  BandAidPlaster = 'Band-aid/Plaster',
  Nickel = 'nickel',
  No = 'No',
  Other = 'other',
  Plastic = 'plastic',
  Plasticizer = 'plasticizer',
  Silicone = 'silicone',
  Unknown = 'Unknown',
  Yes = 'Yes',
}

export enum PreviousExperience {
  EarProtectionAccessory = 'Ear protection/accessory',
  FirstCare = 'First care',
  Unknown = 'unknown',
  FollowupCare = 'Followup care',
  PrematureFollowupCare = 'Premature followup care',
  ExperiencedWearerBTE = 'Experienced Wearer (BTE)',
  ExperiencedWearerITE = 'Experienced Wearer (ITE)',
  FirstTimeWearer = 'First Time wearer',
  PrematureFollowupCareWithoutSubsidy = 'Premature follow-up care w/o subsidy',
  ExperiencedWearerFormerCustomer = 'Experienced Wearer - Former Customer',
}

export enum TypeOfHearingLoss {
  BicrossLeft = 'bicross left',
  BicrossRight = 'bicross right',
  Binaural = 'binaural',
  CrossLeft = 'cross left',
  CrossRight = 'cross right',
  MonauralLeft = 'monaural left',
  MonauralRight = 'monaural right',
  Unknown = 'Unknown',
}

export enum CauseOfHearingLoss {
  Accident = 'Accident',
  AgeRelatedHearingLoss = 'Age-related hearing loss',
  EarSurgery = 'Ear surgery',
  Illness = 'Illness',
  Noise = 'Noise',
  OtherReason = 'Other reason',
  Unknown = 'Unknown',
}

export enum CosiBasicType {
  ChurchTemple = 'Church/Temple',
  Telephone = 'Telephone',
  FreetimeActivities = 'Freetime activities',
  Music = 'Music',
  SocialConversation = 'Social conversation',
  Unknown = 'Unknown',
  ConversationsInNoisyEnvironments = 'Conversations in noisy environments',
  ConversationsInQuietEnvironments = 'Conversations in quiet environments',
  TV = 'TV',
  InTheCar = 'In the car',
  AtWork = 'At work',
  RoomsWithStrongReverb = 'Rooms with strong reverb',
  HearingSituationsInQuietEnvironments = 'Hearing situations in quiet environments',
  MeetingsDistantVoices = 'Meetings / Distant voices',
  OutsideActivities = 'Outside activities',
}

export enum HearingTestAt {
  ENT = 'ENT',
  Audiologist = 'Audiologist',
  Unknown = 'Unknown',
  Generalist = 'Generalist',
  MedicalWorker = 'Medical worker',
}

export enum DiscussedPlatformDevice {
  Primax = 'Primax',
  Signia = 'Signia',
  Oticon = 'Oticon',
  Widex = 'Widex',
  AudibeneHorizon = 'audibene horizon',
  AudibeneIXGo357 = 'audibene IX (go 3/5/7)',
  AudibeneAXGo12CellMax = 'audibene AX (go 1/2, cell, max)',
  SigniaX = 'Signia X',
  SigniaNX = 'Signia NX',
  SigniaAXTechnik12 = 'Signia AX (Technik 1,2)',
  SigniaIXTechnik357 = 'Signia IX (Technik 3,5,7)',
  InsuranceCare = 'Insurance care',
  NoDiscussedPlatform = 'No discussed platform',
  OticonOpnS = 'Oticon Opn S',
  OticonReal = 'Oticon Real',
  WidexMoment = 'Widex Moment',
  WidexMomentSheer = 'Widex Moment Sheer',
  HearComHorizon = 'hear.com horizon',
  AudioService = 'Audio Service',
  Bernafon = 'Bernafon',
  Unitron = 'Unitron',
  SonstigesSieheAnmerkungen = 'Sonstiges (siehe Anmerkungen)',
  AudibeneIX = 'audibene IX',
  SigniaIX = 'Signia IX',
  AudibeneXLite12 = 'audibene X (lite 1/2)',
  None = 'None',
  AudibeneIXGoLite = 'audibene IX (go, lite)',
  AudibeneAXGo1CellMax = 'audibene AX (go 1, cell, max)',
}

export enum DiscussedPriceRange {
  NoDiscussedPriceRange = 'No discussed price range',
  Range700_890 = '700 - 890 € (0 - 190 € with insurance subsidy)',
  Range890_1200 = '890 - 1.200 € (190 - 500 € with insurance subsidy)',
  Range1200_1600 = '1.200 - 1.600 € (500 - 900 € with insurance subsidy)',
  Range1600_1900 = '1.600 - 1.900 € (900 - 1.200 € with insurance subsidy)',
  Range1900_2200 = '1.900 - 2.200 € (1.200 - 1.500 € with insurance subsidy)',
  Range2200_3200 = '2.200 - 3.200 € (1.500 - 2.500 € with insurance subsidy)',
  Euro2000Plus = '€2000+ p. st.',
  Euro1700_2000 = '€1700-€2000 p. st.',
  Euro1500_1700 = '€1500-€1700 p. st.',
  Euro1200_1500 = '€1200-€1500 p. st.',
  Under1500 = 'Under €1500',
  Under1200 = '<€1200 p. st.',
  Under1000CHF = '<1000 CHF',
  Range1000_1500CHF = '1000-1500 CHF',
  Range1500_2000CHF = '1500-2000 CHF',
  Range2000_2500CHF = '2000-2500 CHF',
  Range2500_3000CHF = '2500-3000 CHF',
  Over3000CHF = '3000+ CHF',
  NoAdditionalPayment = 'No additional payment',
  Basisklasse = 'Basisklasse',
  Einstiegsklasse = 'Einstiegsklasse',
  Mittelklasse = 'Mittelklasse',
  UntereMittelklasse = 'Untere Mittelklasse',
  ObereMittelklasse = 'Obere Mittelklasse',
  Oberklasse = 'Oberklasse',
  KeineEinschätzungMöglich = 'Keine Einschätzung möglich',
  Premium = 'Premium',
  Range1300_1600 = '1.300 - 1.600 € (500 - 900 € with insurance subsidy)',
  None = 'None',
}

export enum PreferredDeviceType {
  RIC = 'RIC',
  BTE = 'BTE',
  ITE = 'ITE',
  NoDiscussedDeviceType = 'No discussed device type',
}

export enum Prescription {
  Available = 'Available',
  NotAvailable = 'Not available',
  StillAtOtherAcoustician = 'Still at other acoustician',
  PrescriptionNotNeeded = 'Prescription not needed',
  Unknown = 'Unknown',
  Outdated = 'Outdated',
}

export enum ProfessionalStatus {
  Employed = 'Employed',
  EmployedSelfEmployed = 'Employed / Self-employed',
  Homemaker = 'Homemaker',
  Retired = 'Retired',
  SelfEmployed = 'Self-employed',
  StillWorking = 'Still working',
  Unemployed = 'Unemployed',
  Unknown = 'Unknown',
}

export enum RelevantMedication {
  Antihypertensives = 'Antihypertensives',
  BloodPressureMedication = 'Blood pressure medication',
  BloodThinner = 'Blood thinner',
  CardiacMedications = 'Cardiac medications',
  HeartMedications = 'Heart medications',
  MedicationForDiabetes = 'Medication for Diabetes',
  PsychotropicDrugs = 'Psychotropic drugs',
  None = 'None',
}

export enum YesNoUnknown {
  Yes = 'Yes',
  No = 'No',
  Unknown = 'Unknown',
}

export type HasCurrentHearingTest = YesNoUnknown
export type HasEarInfection = YesNoUnknown
export type HasEarSurgery = YesNoUnknown
export type HasFluctuatingHearingLoss = YesNoUnknown
export type HasSuddenHearingLoss = YesNoUnknown
export type VeteranNoises = Exclude<YesNoUnknown, YesNoUnknown.Unknown>

type MedicalRecord = {
  opportunity_gid: string
  customer_gid: string
  background: {
    has_tinnitus: HasTinnitus | string
    previous_experience: PreviousExperience | string
    hearing_issue_start_date: HearingIssueStartDate | string
    type_of_hearing_loss: TypeOfHearingLoss | string
    motive_for_hearing_aids: string
    lifestyle_notes: string
    cause_of_hearing_loss: CauseOfHearingLoss | string
    allergies: Allergies | string
    comment: string
    cosi_basic_remark_1: string
    cosi_basic_remark_2: string
    cosi_basic_type_1: CosiBasicType | string
    cosi_basic_type_2: CosiBasicType | string
    current_hearing_test_at: HearingTestAt | string
    desired_features: DesiredFeaturesOptions
    discussed_platform_device: DiscussedPlatformDevice | string
    discussed_price_range: DiscussedPriceRange | string
    former_profession: string
    has_current_hearing_test: HasCurrentHearingTest | string
    has_ear_infection: HasEarInfection | string
    has_ear_surgery: HasEarSurgery | string
    has_fluctuating_hearing_loss: HasFluctuatingHearingLoss | string
    has_sudden_hearing_loss: HasSuddenHearingLoss | string
    has_veteran_noises: VeteranNoises | string
    hobbies: string
    insurance_name: string
    preferred_device_type: PreferredDeviceType | string
    preliminary_insurance_name: string
    prescription: Prescription | string
    professional_status: ProfessionalStatus | string
    relevant_medication: RelevantMedication | string
    scale_of_prescription: ScaleOfPrescription | string
    smartphone: Smartphone | string
  }
}

export type { MedicalRecord }
